import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useMemo } from "react";
import { useTranslate } from "ra-core";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const MYSelectInput = ({ name, choices, value, label, hasError, onChange }) => {
  const translate = useTranslate();
  const id = useMemo(() => makeid(10), []);
  const handleChange = (event) => onChange(event);
  return (
    <FormControl error={hasError} variant="filled" fullWidth>
      <InputLabel id={id}>{translate(label)}</InputLabel>
      <Select
        labelId={id}
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        label={translate(label)}
      >
        {choices.map((choice) => (
          <MenuItem key={choice.id} value={choice.id}>
            {choice.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MYSelectInput;
